import { Component, EventEmitter, Output } from '@angular/core';
import { whats } from '../../utils/phone.utils';

@Component({
	selector: 'cmv-whatsapp-btn',
	templateUrl: './whatsapp-btn.component.html',
	styleUrls: ['./whatsapp-btn.component.scss'],
})
export class WhatsappBtnComponent {
	constructor() {}

	onClick() {
		whats();
	}
}
